import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchLeadProjectStages = createAsyncThunk("fetchLeadProjectStages", async ({ page, limit }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`category/list?page=${page}&limit=${limit}&category=leadProjectStage`, config);

	return response.data.data;
});

const LeadProjectStagesSlice = createSlice({
	name: "LeadProjectStagesSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchLeadProjectStages.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchLeadProjectStages.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchLeadProjectStages.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default LeadProjectStagesSlice.reducer;
